import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MarsLicenseProgressListService } from './mars-license-progress-list.service';
import { StoreService } from 'core/index';

@Component({
  selector: 'lms-mars-license-progress-list',
  templateUrl: './mars-license-progress-list.component.html',
  styleUrls: ['./mars-license-progress-list.component.scss'],
  providers: [MarsLicenseProgressListService]
})
export class MarsLicenseProgressListComponent implements OnInit {
  @Input() license: any;
  @Input() showToolbar: boolean = true;
  progressData: any[] = [];
  toolbarConfig: any;
  filters: any;
  listOptions: any;
  datasource: any;
  listId: string = 'MARS_LICENSE_PROGRESS_LIST';
  licenseListId: string;

  constructor(private marsLicenseProgressListService: MarsLicenseProgressListService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.licenseListId = this.listId + '_' + Date.now();
    this.toolbarConfig = {
      list: {
        listId: this.licenseListId,
        download: false,
        filterRow: false,
        columnChooser: false,
        skeletor: true,
        hidePrint: true
      }
    };
  }

  async ngOnChanges() {
    this.datasource = await this.marsLicenseProgressListService.getDatasource(
      this.licenseListId,
      this.listOptions,
      this.license
    );
    this.cdr.detectChanges();
  }

  onDatasourceUpdate(dataSource) {
    this.datasource = dataSource;
    StoreService.update(this.licenseListId, this.datasource);
  }
}
